import { InputFilterTrigger } from '@shared/features/views/components/static-filter-inputs';

import { leadIncludeFilterConfig } from '@shared/features/views/configs';

export const LeadIncludeFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Include'
      config={leadIncludeFilterConfig}
    />
  );
};
